import React, { useEffect, useState } from 'react';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white border-t border-gray-200 p-3 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] transition-transform duration-300 ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-56">
      <a href="[CART_LINK]" className="block w-full bg-accent text-white font-bold text-lg py-3 px-4 rounded-xl text-center shadow-md active:scale-95 transition-transform" data-id="element-57">
        QUIERO EL SISTEMA AHORA →
      </a>
    </div>;
}